import React, { useState, useRef, useEffect } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { connect } from 'react-redux';
import useMonitorAPIService from '../../services/monitorapiservice';
import cryptoJs from 'crypto-js';
import Toastr from '../utils/toastr';
import BlockUi from 'react-block-ui';

function ChangePassword(props) {

    const { t } = useTranslation();
    const { changePassword, getPasswordPolicy } = useMonitorAPIService();
    const toastrRef = useRef(null);

    const [oldPwd, setOldPwd] = useState("");
    const [isEmptyOldPwd, setIsEmptyOldPwd] = useState(false);
    const [newPwd, setNewPwd] = useState("");
    const [isEmptyNewPwd, setIsEmptyNewPwd] = useState(false);
    const [oldAndNewMatch, setOldAndNewMatch] = useState(false);
    const [invalidPwdPolicy, setInvalidPwdPolicy] = useState(false);
    const [cnfpwd, setCnfpwd] = useState("");
    const [doesNotMatchNewPwd, setDoesNotMatchNewPwd] = useState("");
    const [loading, setLoading] = useState(false);
    const [passwordPolicy, setPasswordPolicy] = useState(false);

    useEffect(() => {
        if (props.show) {
            setLoading(true);

            let data = {
                "userId": props.id
            };

            getPasswordPolicy(props.token, data, res => {             

                setOldPwd("");
                setIsEmptyOldPwd(false);
                setNewPwd("");
                setIsEmptyNewPwd(false);
                setOldAndNewMatch(false);
                setInvalidPwdPolicy(false);
                setCnfpwd("");
                setDoesNotMatchNewPwd("");

                setPasswordPolicy(res.data);  
                setLoading(false);
                
            });

        }
          // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const handleOldPassword = (value) => {
        setOldPwd(value);
        setIsEmptyOldPwd(value === null || (value !== null && value.trim() === ""));
    }

    const handleNewPwd = (value) => {
        setNewPwd(value);
        setIsEmptyNewPwd(value === null || (value !== null && value.trim() === ""));
        setDoesNotMatchNewPwd(value !== cnfpwd);
        setOldAndNewMatch(value === oldPwd);

        if (passwordPolicy)
            setInvalidPwdPolicy(!new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z][^*]{8,}$/).test(value));
    }

    const handleCnfPwd = (value) => {
        setCnfpwd(value);
        setDoesNotMatchNewPwd(value !== newPwd);
    }

    const changePwd = e => {

        setLoading(true);

        let data = {
            id: props.id,
            oldPassword: cryptoJs.SHA512(oldPwd).toString(),
            newPassword: cryptoJs.SHA512(newPwd).toString()
        };

        changePassword(props.token, data, res => {

            if (!res) {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            } else {
                toastrRef.current.setType("success");
                toastrRef.current.setMessage(t("dataupdated"));
                toastrRef.current.show();
                localStorage.removeItem("faChangePwd");
            }

            setLoading(false);
            props.toggleModal();

        });

    }

    return (
        <>
            <Modal show={props.show} onHide={props.toggleModal} size="lg" backdrop={props.changePassword ? "static" : true}>
                <BlockUi tag="div" blocking={loading} color="#009ef7" message={t("pleasewait")}>
                    {
                        !props.changePassword &&
                        <Modal.Header>
                            <Modal.Title><FontAwesomeIcon icon={duotone("key")} /> {t("changepassword")}</Modal.Title>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {t("close")}
                                </Tooltip>}>
                                <Button onClick={props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                            </OverlayTrigger>
                        </Modal.Header>

                    }
                    {
                        props.changePassword &&
                        <Modal.Header>
                            <Modal.Title><FontAwesomeIcon icon={duotone("key")} /> {t("changepassword")}</Modal.Title>
                        </Modal.Header>
                    }

                    <Modal.Body>
                        <Row>
                            <Col>
                                <Form>
                                    <Form.Group className="mb-4" controlId="fcoldpwd" >
                                        <Form.Label>{t("oldpwd")}</Form.Label>
                                        <Form.Control type="password" value={oldPwd} onChange={e => handleOldPassword(e.target.value)} isInvalid={isEmptyOldPwd} />
                                        <Form.Text className="text-muted">
                                        </Form.Text>

                                        {
                                            (isEmptyOldPwd) &&
                                            <Form.Text id="passwordHelpBlock" className='text-danger'>
                                                {t("oldpasswordisempty")}
                                            </Form.Text>
                                        }

                                    </Form.Group>
                                    <Form.Group className="mb-4" controlId="fcnewpwd" >
                                        <Form.Label >{t("newpwd")}</Form.Label>
                                        <Form.Control type="password" value={newPwd} onChange={e => handleNewPwd(e.target.value)} isInvalid={isEmptyNewPwd || oldAndNewMatch || invalidPwdPolicy} />
                                        <Form.Text className="text-muted">
                                        </Form.Text>

                                        {
                                            (isEmptyNewPwd) &&
                                            <Form.Text className='text-danger'>{t("newpasswordisempty")}</Form.Text>
                                        }

                                        {
                                            (oldAndNewMatch) &&
                                            <Form.Text className='text-danger'>{t("oldandnewpwdmatch")}</Form.Text>
                                        }

                                        {
                                            (invalidPwdPolicy) &&
                                            <Form.Text className='text-danger'>{t("newpwdmismatchpolicy")}</Form.Text>
                                        }

                                    </Form.Group>
                                    <Form.Group className="mb-4" controlId="fccnfpwd" >
                                        <Form.Label>{t("cnfpwd")}</Form.Label>
                                        <Form.Control type="password" value={cnfpwd} onChange={e => handleCnfPwd(e.target.value)} isInvalid={doesNotMatchNewPwd} />
                                        <Form.Text className="text-muted">
                                        </Form.Text>

                                        {
                                            (doesNotMatchNewPwd) &&
                                            <Form.Text id="passwordHelpBlock" className='text-danger'>{t("passworddoesnotmatch")}</Form.Text>
                                        }
                                    </Form.Group>
                                </Form>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={changePwd}>
                            <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {t("send")}
                        </Button>
                    </Modal.Footer>
                </BlockUi>
            </Modal>
            <Toastr ref={toastrRef} />
        </>
    )

}


const mapStateToProps = (state) => {
    return {
        changePassword: state.supervisor.changePassword,
        id: state.supervisor.id,
        token: state.supervisor.token
    };
};
export default connect(mapStateToProps, {})(ChangePassword);